<template>
  <div id="dinnerMonth">
        <i-col span="24" style="padding: 0 20px;">
            <div class="query-bar">
                <Form class="rightTop" ref="formInline" :model="formInline" inline :label-width="80">
                		<h4>就餐记录</h4>
                    <Form-item>
                        <DatePicker  type="month" v-model="formInline.month" style="width: 200px"></DatePicker>
                    </Form-item>
                    <Button type="primary" @click="submitSearch(actionPage)">搜索</Button>
                    <Button class="addBtn" type="primary" @click="getExcel" style="float: right;margin-top: 0;"><Icon type="plus-round"></Icon>导出excel表</Button>
                </Form>
            </div>
            <div class="center">
                <Table style="margin-bottom: 50px;;" border :data="departmentData" :columns="theadArr" stripe></Table>
                <!--<Page class="pull-right" :total="totalSize" :current="page" :page-size="pageSize"  show-total @on-change="changePage"></Page>-->
            </div>
            <Spin v-show="no_data" fix>
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>加载中...</div>
            </Spin>
            <Modal
                v-model="showMoadl"
                title="修改订餐信息" 
                ok-text="修改" 
                @on-ok="xiugai"
                >
                <Row style="margin-bottom: 30px;text-align: center;">
                    <input type="text" disabled v-model="modalRealname" style="width: 300px">                     
                </Row>
                <Row style="margin-bottom: 30px;text-align: center;">
                    <DatePicker readonly disable type="date" v-model="modalMonth" style="width: 300px"></DatePicker>
                </Row>
                <Row style="text-align: center;">
                    <Checkbox v-model="modalBreakfast">早餐</Checkbox>
                    <Checkbox v-model="modalLunch">午餐</Checkbox>                    
                </Row>
            </Modal>
            <Modal
                v-model="showMoad2"
                title="修改招待信息" 
                ok-text="修改" 
                @on-ok="shanchu"
                >
                <Row style="margin-bottom: 30px;text-align: center;">
                    <input type="text" disabled v-model="modalRealname" style="width: 300px">                     
                </Row>
                <Row style="margin-bottom: 30px;text-align: center;">
                    <DatePicker readonly disable type="date" v-model="modalMonth" style="width: 300px"></DatePicker>
                </Row>
                <Row style="text-align: center;">
                    <Checkbox :disabled="disable1" v-model="modalBreakfast">早餐</Checkbox>
                    <Checkbox :disabled="disable2" v-model="modalLunch">午餐</Checkbox>                    
                </Row>
            </Modal>
        </i-col>
    </div>
</template>

<script>
export default {
        data () {
            return {
                disable1:true,
                disable2:true,
                zdStr:"",
                showMoad2:false,
                showMoadl:false,
                modalRealname:"",
                modalMonth:"",
                modalBreakfast:false,
                modalLunch:false,
                no_data:false,
                formItem: {},
                updateTitle: "",
                formInline: {
                    month:new Date()
                },
                departmentData:[],
                theadArr: [{
                    title: "人员",
                    width: 115,
                    key: "realname",
                    fixed: "left"
                }],
                btnSave: false,
                btnChange: false,
                modal1: false,
                selectPeopleShow:false,
                SelectPersonData:{},
                actionPage: 1,
                totalSize:0,//总条数
                pageSize:10,//每页显示数
                page:1,//当前页
            }
        },
        methods: {
            xiugai(){
                let that = this;
                let params = {};
                params.data = {
                    "realname":this.modalRealname,
                    "meal_date":this.modalMonth.format("yyyy-MM-dd"),
                    "breakfast":this.modalBreakfast,
                    "lunch":this.modalLunch
                };
                console.log(params);
                params.url = "/sys/mealrecord/editRecord";
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    that.changQuery(that.actionPage);
                    that.$Message.success(res.data.message);
                };
                this.ajaxPost(params);
            },
            shanchu(){
                let that = this;
                let params = {};
                params.data = {
                    "realname":this.modalRealname,
                    "meal_date":this.modalMonth.format("yyyy-MM-dd"),
                    "breakfast":this.modalBreakfast,
                    "lunch":this.modalLunch
                };
                console.log(params);
                params.url = "/sys/mealrecord/editRecord";
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    that.changQuery(that.actionPage);
                    that.$Message.success(res.data.message);
                };
                this.ajaxPost(params);                
            },
            changQuery(){
                this.submitSearch(this.actionPage)
            },
            getExcel(){
                let that = this;
                let params = {};
                params.data = {
                    stat_month: that.formInline.month.format("yyyy-MM")
                };
                params.url = "/sys/mealstat/statDetailedExcel";
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    var fileName = "就餐信息2.xls";
                    var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                    var downloadElement = document.createElement('a');
                　　var href = window.URL.createObjectURL(blob); //创建下载的链接
                　　downloadElement.href = href;
                　　downloadElement.download = fileName; //下载后文件名
                　　document.body.appendChild(downloadElement);
                　　downloadElement.click(); //点击下载
                　　document.body.removeChild(downloadElement); //下载完成移除元素
                　　window.URL.revokeObjectURL(href); //释放掉blob对象 
                };
                this.ajaxGet(params);
            },
            sendBack(i,str,name,row){
                if(name.indexOf("招待") != -1){
                    var time = new Date(this.formInline.month.format("yyyy"),this.formInline.month.format("MM")-1,i);
                    if(time> new Date()){
                        this.$Message.warning({
                            content: "请选择当天之前的日期"
                        })
                    }else if(str == "-"){
                        this.$Message.warning({
                            content: "请选择有招待的日期"
                        })
                    }else{
                        this.showMoad2 = true;
                        this.modalRealname = name;
                        this.modalMonth = time;
                        if(str == "早/午"){
                            this.modalBreakfast = true;
                            this.modalLunch = true;
                            this.disable1 = false;
                            this.disable2 = false;
                        }else if(str == "-"){
                            this.modalBreakfast = false;
                            this.modalLunch = false;
                            this.disable1 = true;
                            this.disable2 = true;
                        }else if(str == "早"){
                            this.modalBreakfast = true;
                            this.modalLunch = false;
                            this.disable1 = false;
                            this.disable2 = true;
                        }else if(str == "午"){
                            this.modalBreakfast = false;
                            this.modalLunch = true;
                            this.disable1 = true;
                            this.disable2 = false;
                        }
                    }
                }else{
                    var time = new Date(this.formInline.month.format("yyyy"),this.formInline.month.format("MM")-1,i);
                    if(time> new Date()){
                        this.$Message.warning({
                            content: "请选择当天之前的日期"
                        })
                    }else{
                        this.disable1 = true;
                        this.disable2 = true;
                        this.showMoadl = true;
                        this.modalRealname = name;
                        this.modalMonth = time;
                        if(str == "早/午"){
                            this.modalBreakfast = true;
                            this.modalLunch = true;
                        }else if(str == "-"){
                            this.modalBreakfast = false;
                            this.modalLunch = false;
                        }else if(str == "早"){
                            this.modalBreakfast = true;
                            this.modalLunch = false;
                        }else if(str == "午"){
                            this.modalBreakfast = false;
                            this.modalLunch = true;
                        }
                    }
                    
                }
            },
            submitSearch: function(page) {
                this.no_data=true
                page = page == "" || page == undefined ? this.page : page;
                let that = this;
                let params = {};
                params.data = {
                    page: page,
                    pageSize: this.pageSize,
                    order: { _id: -1 },
                    stat_month: that.formInline.month.format("yyyy-MM")
                };
                params.url = "/sys/mealstat/statdetailed";
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    res = res.data;
		                    that.theadArr = [{
		                    title: "人员",
		                    width: 115,
		                    key: "realname",
		                    fixed: "left"
		                }];
                    var len = res.result.day_count;
                    var getData = res.result.result;
                    for(let i=0;i<len;i++){
                        that.theadArr.push({
                            title: i+1,
                            width: 100,
                            key: i+1,
                            render: (h, par) => {
                            let rowData = par.row;
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            size: 'small'
                                        },
                                        style: {
                                            height: '100%',
                                            width: '100%',
                                            position:"absolute",
                                            left:"0",
                                            top:"0"
                                        },
                                        on: {
                                            click: () => {
                                                // that.sendBack(i+1,rowData[i+1],par.row.realname,par.row)
                                            }
                                        }
                                    }, rowData[i+1]),
                                ]);
                            }
                        })
                    }
                    that.theadArr.push({
                        title: "早餐小计",
                        width: 85,
                        key: "breakfast_count",
                        fixed: "right"
                    });
                    that.theadArr.push({
                        title: "午餐小计",
                        width: 85,
                        key: "lunch_count",
                        fixed: "right"
                    });
                  that.theadArr.push({
                    title: "晚餐小计",
                    width: 85,
                    key: "dinner_count",
                    fixed: "right"
                  });
                    that.departmentData = res.result.stat_list;
                    // console.log(that.departmentData);
                    that.totalSize = res.result.totalSize;
                    that.page = res.result.page;
                    that.no_data=false
                };
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.submitSearch(page);
                this.actionPage = page;
            }
        },
        mounted: function() {
        	  var curDate = new Date();
		        /* 获取当前月份 */
		        var curMonth = curDate.getMonth();
		        curDate.setMonth(curMonth + 1);
		        curDate.setDate(0);
		        for(var i=0;i<curDate.getDate();i++){
		        	this.theadArr.push({
                    title: i+1,
                    width: 55,
                    key: i
                })
		        }
		        this.theadArr.push({
                title: "早餐小计",
                width: 85,
                key: "breakfast_count",
                fixed: "right"
            });
            this.theadArr.push({
                title: "午餐小计",
                width: 85,
                key: "lunch_count",
                fixed: "right"
            });
          this.theadArr.push({
            title: "晚餐小计",
            width: 85,
            key: "dinner_count",
            fixed: "right"
          });
            this.submitSearch(this.page);
        }
    }
</script>

<style lang="scss">
	#dinnerMonth{
		.query-bar{
			background: transparent;
			height: 80px;
			padding-top: 20px;
			margin-bottom: 30px;
			border-bottom: 1px solid #e9eaec;
		}
		table{
			text-align: center;
			th{
				height: 50px;
				font-size: 16px;
			}
			th,td{
				text-align: center;
                position: relative;
                .ivu-btn-small{
                    background: transparent;
                    border: 0;
                }
			}
			/*td:nth-child(2){
				display: none;
			}
			th:nth-child(2){
				display: none;
			}*/
		}
		.ivu-page{
	    	margin-top: 30px;
	    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
		.rightTop{
			h4{
				font-size: 18px;
				color: #45AAF9;
				float: left;
				text-align: left;
			}
			text-align: left;
			.ivu-form-item{
				text-align: left;
			}
		}
	}
</style>
<style lang="scss" scoped>
    #dinnerMonth{
	    .addBtn{
	        margin-top: 5px;
	        margin-bottom: 5px;
	    }
	    .ml32{
	        height: 36px;
	        line-height: 36px;
	    }
	    .ivu-form-item {
	        margin-bottom: 0px;
	    }
    }
</style>




// WEBPACK FOOTER //
// src/components/dinnerMana/dinnerMonth.vue